module.exports = __webpack_public_path__ + "img/truck-performance.c2ef8e3d.svg";